import { api } from "../api";

export const projectViewApi = (params) => {
  return api.get(`/api/admin/project/view?project_id=${params?.project_id}`);
};
export const projectUpdateApi = (data) => {
  return api.post("/api/admin/project/approve-reject", JSON.stringify(data));
};
